(ns common.widgets.content-function-version-selector
  (:require [common.widgets.toggle-button :refer [toggle-button-group]]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui button-group
  "Returns hiccup as button group for selecting content function version"
  [{:keys [on-change disabled?]}]
  (let [value (:name (use-subscribe [:resource.content-function-version/active-version]))
        options (use-subscribe [:resource.content-function-version/version-options])]
    ($ toggle-button-group
       (cond-> {:options options
                :value value
                :data-component :button-group-cfn-versions
                :disabled? disabled?}
         (fn? on-change) (assoc :on-change on-change)))))
